import { useEffect, useState } from 'react';

import type { ResolvedApplicationColorScheme } from '@shared/providers/application-state';
import { useApplicationState } from '@shared/providers/application-state';

const prefersDarkColorScheme = '(prefers-color-scheme: dark)';

function resolveSystemColorScheme(): ResolvedApplicationColorScheme {
	return window.matchMedia(prefersDarkColorScheme).matches ? 'dark' : 'light';
}

function useSystemColorScheme(): ResolvedApplicationColorScheme {
	const [colorScheme, setColorScheme] =
		useState<ResolvedApplicationColorScheme>(resolveSystemColorScheme);

	useEffect(() => {
		const mediaQueryList = window.matchMedia(prefersDarkColorScheme);

		setColorScheme(mediaQueryList.matches ? 'dark' : 'light');

		const onChange = (event: MediaQueryListEvent) => {
			setColorScheme(event.matches ? 'dark' : 'light');
		};

		mediaQueryList.addEventListener('change', onChange);

		return () => mediaQueryList.removeEventListener('change', onChange);
	}, []);

	return colorScheme;
}

export function useCurrentColorScheme(): ResolvedApplicationColorScheme {
	const { colorScheme } = useApplicationState();
	const systemColorScheme = useSystemColorScheme();

	return colorScheme === 'system' ? systemColorScheme : colorScheme;
}
